import { render, staticRenderFns } from "./ApplyGoldWithdrawal.vue?vue&type=template&id=26ffbc54&scoped=true"
import script from "./ApplyGoldWithdrawal.vue?vue&type=script&lang=js"
export * from "./ApplyGoldWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./ApplyGoldWithdrawal.vue?vue&type=style&index=0&id=26ffbc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ffbc54",
  null
  
)

export default component.exports